import React, { useMemo } from 'react';
import { FaHome } from 'react-icons/fa';
import { FiChevronRight } from 'react-icons/fi';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { routesConfig } from '../sidebar/routesConfig';

const LinkBase = styled(NavLink)`
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 400;
  color: #949fb1;
  display: flex;
  align-items: center;

  svg {
    font-size: 1.2rem;
    margin-right: 10px;
    color: #d3dae3;
  }
`;

const BreadcrumbContainer = styled.nav`
  display: flex;
  align-items: center;
  margin: 0 12px 20px 0;
`;

function findRoutePath(tree, pathname, parents = []) {
  for (const node of tree) {
    const current = [...parents, node];

    if (node.route === pathname) return current;

    if (node.subMenu?.length) {
      const nested = findRoutePath(node.subMenu, pathname, current);
      if (nested) return nested;
    }
  }
  return null;
}

function isDetailRoute(route) {
  if (!route) return false;

  return (
    route.endsWith('/detail') ||
    route.includes('/detail/') ||
    route.endsWith('/table') ||
    route.endsWith('/unico/detail') ||
    route.endsWith('/biometrics/detail')
  );
}

const Breadcrumbs = () => {
  const location = useLocation();
  const history = useHistory();
  const path = location.pathname;

  const trail = useMemo(() => {
    return findRoutePath(routesConfig, path) || null;
  }, [path]);

  if (!trail) return null;

  const last = trail[trail.length - 1];
  const isDetail = isDetailRoute(last.route);
  const generateLink = (route: string) => {
    if (isDetail || route === '') {
      return route
        .replace('/unico/detail', '')
        .replace('/banknow/detail', '')
        .replace('/detail', '')
        .replace('/table', '')
        .replace('/faturasPagas', '')
        .replace('/faturasEmAtraso', '');
    }
    return route;
  };
  if (last.bread) {
    return (
      <BreadcrumbContainer>
        <LinkBase to="/homeDash">
          <FaHome />
        </LinkBase>

        {last.bread.map((item, idx) => {
          const { disabled, label, to, goBack } = item;

          return (
            <React.Fragment key={idx}>
              <FiChevronRight />

              {disabled ? (
                <span
                  style={{
                    fontSize: '0.875rem',
                    marginLeft: 8,
                    marginRight: 8,
                    color: '#2e3958',
                  }}
                >
                  {label}
                </span>
              ) : goBack ? (
                <span
                  onClick={() => history.goBack()}
                  style={{
                    cursor: 'pointer',
                    fontSize: '0.875rem',
                    marginLeft: 8,
                    marginRight: 8,
                    color: '#2e3958',
                  }}
                >
                  {label}
                </span>
              ) : (
                <LinkBase
                  to={to}
                  activeStyle={{ color: '#2e3958' }}
                  style={{ color: '#2e3958', marginRight: 8 }}
                >
                  {label}
                </LinkBase>
              )}
            </React.Fragment>
          );
        })}
      </BreadcrumbContainer>
    );
  }
  return (
    <BreadcrumbContainer>
      <LinkBase to="/homeDash">
        <FaHome />
      </LinkBase>

      {trail.map((item, idx) => (
        <React.Fragment key={item.route || idx}>
          <FiChevronRight />
          <LinkBase
            to={generateLink(item.route)}
            activeStyle={{ color: '#2e3958' }}
            style={{ color: '#2e3958', marginRight: 8, marginLeft: 8 }}
          >
            {item.label}
          </LinkBase>
        </React.Fragment>
      ))}

      {isDetail && (
        <>
          <FiChevronRight />
          <span
            style={{
              fontSize: '0.875rem',
              color: '#2e3958',
              marginLeft: 8,
              marginRight: 8,
            }}
          >
            Detalhes
          </span>
        </>
      )}
    </BreadcrumbContainer>
  );
};

export default Breadcrumbs;
